import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';

export function ReactQueryProvider({ children }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Caching disabled app-wide, per explicit request — stale/
            // out-of-date data (server-side changes not showing up on the
            // frontend) was a recurring concern across several pages.
            // staleTime: 0 means every query is considered stale the moment
            // it lands, so any mount/remount/window-refocus refetches rather
            // than silently serving a cached value. refetchOnWindowFocus is
            // on to match — a background tab shouldn't sit on stale data
            // after switching back. gcTime is left as-is — it only controls
            // how long unused data stays in memory before garbage
            // collection, not whether it's served as "fresh". The one
            // deliberate exception is useReferenceData
            // (src/services/api/queries/referenceDataQueries.js), which
            // keeps its own long staleTime since that data (locations,
            // fields of study, etc.) is genuinely stable — every other query
            // hook must NOT set its own staleTime/refetchOnWindowFocus
            // override, or it'll silently opt back into caching despite this
            // default.
            staleTime: 0,
            gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime in v4)
            retry: 1,
            refetchOnWindowFocus: true,
            refetchOnMount: true, // Refetch when component mounts to ensure fresh data
          },
          mutations: {
            retry: 1,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
